export var calculateRoute = function calculateRoute(lat1, lng1, street, city, state, zip) {
  if (!lat1 || !lng1) return;
  return 'https://www.google.com/maps/dir/?api=1&origin=' + lat1 + ',' + lng1 + '&' + 'destination=' + street + '+' + city + '+' + zip;
};